import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import moment from "moment";
import { useSelector } from "react-redux";
import * as utils from "../../Utils/comman";
import "./attendance-report.css";
import { useLoader } from "../../Loader";
import { DocumentDownload } from "iconsax-react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Select from "react-select";

function Report() {
  const [attendance, setAttendance] = useState({});
  const [month, setMonth] = useState(
    String(new Date().getMonth() + 1).padStart(2, "0")
  );
  const [loading, setLoading] = useState(true);
  const [year, setYear] = useState(new Date().getFullYear());
  const { startLoader, stopLoader } = useLoader();
  const [departmentFilter, setDepartmentFilter] = useState(null);

  const [EmpName, setEmpName] = useState("");
  const [EmpCode, setEmpCode] = useState("");
  const [department, setDepartment] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);

  useEffect(() => {
    getDepartmentList();
  }, []);

  const getDepartmentList = () => {
    utils
      .callAPI("get", `/department/list`)
      .then((res) => {
        if (res?.result) {
          const active = res.result
            .filter((item) => item.isActive === "1")
            .map((dept) => ({
              label: dept.department_name,
              value: dept.department_name,
            }));
          setDepartment(active);
        }
      })
      .catch(() => setDepartment([]));
  };

  const months = [
    { label: "January", value: "01" },
    { label: "February", value: "02" },
    { label: "March", value: "03" },
    { label: "April", value: "04" },
    { label: "May", value: "05" },
    { label: "June", value: "06" },
    { label: "July", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 2023 + 1 },
    (_, i) => 2023 + i
  );

  useEffect(() => {
    getAttendanceList();
  }, [month, year]);

  const getAttendanceList = () => {
    startLoader();
    const apiUrl = `/Attendance/monthly-attendance-download?month=${month}&year=${year}`;
    utils
      .callAPI("get", apiUrl)
      .then((res) => {
        setAttendance(res || []);
        setLoading(false);
        stopLoader();
      })
      .catch(() => {
        setAttendance([]);
        setLoading(false);
        stopLoader();
      });
  };

  const handleDownload = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Attendance");

    const staticHeaders = ["Sr No", "Emp Name", "Emp code", "Department"];
    const dateHeaders = Array.from({ length: 31 }, (_, i) => `${i + 1}`);

    // Leave types from data
    const leaveTypes = new Set();
    attendance?.rows.forEach((row) => {
      Object.keys(row.leave_counts || {}).forEach((type) =>
        leaveTypes.add(type)
      );
    });
    const dynamicLeaveTypes = Array.from(leaveTypes);

    const summaryHeaders = [
      ...dynamicLeaveTypes,
      "Holiday",
      "Travel",
      "wfh",
      "Present",
    ];

    // -------- Header Row 1 --------
    const row1 = [
      ...staticHeaders,
      ...dateHeaders,
      "Total",
      ...Array(summaryHeaders.length - 1).fill(""),
    ];
    worksheet.addRow(row1);
    worksheet.views = [
      {
        state: "frozen",
        ySplit: 2,
      },
    ];

    // Merge the "Total" cell
    const totalStartCol = staticHeaders.length + dateHeaders.length + 1;
    const totalEndCol = totalStartCol + summaryHeaders.length - 1;
    worksheet.mergeCells(1, totalStartCol, 1, totalEndCol);

    // Style Row 1
    const headerRow1 = worksheet.getRow(1);
    headerRow1.eachCell((cell, colNumber) => {
      cell.font = { bold: true };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFF00" }, // Yellow
      };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // -------- Header Row 2 --------
    const dayNameRow = [...attendance?.day_names];
    worksheet.addRow(dayNameRow);
    worksheet.views = [
      {
        state: "frozen",
        ySplit: 2,
      },
    ];

    // Style Row 2
    const headerRow2 = worksheet.getRow(2);
    headerRow2.eachCell((cell, colNumber) => {
      cell.font = { italic: true };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      if (cell.value !== "Sun") {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "4472C4" }, // Light blue
        };
      }
    });

    // -------- Attendance Status Color Mapping --------
    const statusColors = {
      P: "CCFFCC", // green
      A: "", // red (not applied here)
      L: "FFD966", // light orange
      H: "9BC2E6", // blue
      T: "FFFF99", // yellow
      W: "E5CCFF", // purple
      PL: "FFFFFF",
      SL: "FFFFFF",
      CL: "FFFFFF",
    };

    // -------- Employee Data --------
    attendance?.rows.forEach((emp) => {
      const row = [
        emp.sr_no,
        emp.employee_name,
        emp.employee_code,
        emp.department,
        ...Array.from(
          { length: 31 },
          (_, i) => emp.attendance[i + 1]?.toUpperCase?.() || ""
        ),
        ...dynamicLeaveTypes.map((type) => emp.leave_counts?.[type] || "0"),
        emp?.holiday,
        emp?.travelCount,
        emp?.wfhCount,
        emp?.present,
      ];
      const r = worksheet.addRow(row);

      for (let i = 4; i < 4 + 31; i++) {
        const cell = r.getCell(i + 1);
        const val = cell.value?.toString()?.toUpperCase();
        const color = statusColors[val];

        if (val && val !== "P" && val !== "A" && !color) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "F4B084" },
          };
        } else if (color) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: color },
          };
        }
      }
    });

    // -------- Sunday Highlighting --------
    for (let i = 5; i < 36; i++) {
      const day = worksheet.getRow(2).getCell(i).value;
      if (day === "Sun") {
        worksheet.getColumn(i).eachCell((cell, rowNumber) => {
          if (rowNumber >= 2) {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FF0000" }, // red
            };
          }
        });
      }
    }

    // -------- Total Manpower Row --------
    const totalManpowerRow = worksheet.addRow([
      "",
      "",
      "",
      "Total Manpower",
      ...Array(31 + summaryHeaders.length).fill(""),
    ]);
    totalManpowerRow.font = { bold: true };
    totalManpowerRow.getCell(4).fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "92D050" }, // green
    };

    // -------- Footer Row with Zeroes --------
    const footerRow = worksheet.addRow([
      "",
      "",
      "",
      "",
      ...Array(31 + summaryHeaders.length).fill(0),
    ]);
    footerRow.eachCell((cell, colNumber) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "BDD7EE" }, // blue
      };
      cell.alignment = { horizontal: "center" };
    });

    worksheet.columns.forEach((col, index) => {
      if (index === 0) {
        col.width = 6; // Sr No
      } else if (index === 1 || index === 2 || index === 3) {
        col.width = 15; // Emp Name, Emp Code, Department
      } else {
        col.width = 6; // All others
      }
      col.alignment = { horizontal: "center", vertical: "middle" };
    });

    // -------- Export --------
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `Attendance_Report_${month}_${year}.xlsx`);
    });
  };

  useEffect(() => {
    if (attendance?.rows?.length) {
      setFilteredRows(attendance.rows);
    }
  }, [attendance]);

  const handleSearch = () => {
    const filtered = attendance.rows.filter((row) => {
      const matchName = EmpName
        ? row.employee_name?.toLowerCase().includes(EmpName.toLowerCase())
        : true;
      const matchCode = EmpCode
        ? row.employee_code?.toLowerCase().includes(EmpCode.toLowerCase())
        : true;
      const matchDept = departmentFilter
        ? row.department === departmentFilter.value
        : true;
      return matchName && matchCode && matchDept;
    });
    setFilteredRows(filtered);
  };

  const handleReset = () => {
    setEmpName("");
    setEmpCode("");
    setDepartmentFilter(null);
    setFilteredRows(attendance.rows);
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header>
          <h4></h4>

          <div className="card-header-action">
            <RB.Row className="justify-content-end align-items-center">
              <RB.Col md={5} className="mb-2">
                <RB.Form.Select
                  value={month}
                  onChange={(e) => setMonth(e.target.value)}
                >
                  {months.map((m) => (
                    <option key={m.value} value={m.value}>
                      {m.label}
                    </option>
                  ))}
                </RB.Form.Select>
              </RB.Col>
              <RB.Col md={5} className="mb-2">
                <RB.Form.Select
                  value={year}
                  onChange={(e) => setYear(Number(e.target.value))}
                >
                  {years.map((y) => (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  ))}
                </RB.Form.Select>
              </RB.Col>
              <RB.Col md={2} className="text-end">
                <RB.Button
                  size="sm"
                  variant="primary"
                  className="btn-circle"
                  onClick={handleDownload}
                  disabled={loading}
                >
                  <DocumentDownload />
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </div>
        </RB.Card.Header>

        <RB.Card.Body className="attendance-scroll-container">
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "200px" }}
            >
              <div className="spinner-border text-warning" role="status">
                <span className="visually-hidden">Loading Attendance...</span>
              </div>
            </div>
          ) : (
            attendance &&
            Object.keys(attendance).length !== 0 && (
              <>
                <RB.Row className="mb-3">
                  <RB.Col md={3} className="mb-2">
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Employee Name"
                      value={EmpName}
                      onChange={(e) => setEmpName(e.target.value)}
                      required
                    />
                  </RB.Col>
                  <RB.Col md={3} className="mb-2">
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Employee Code"
                      value={EmpCode}
                      onChange={(e) => setEmpCode(e.target.value)}
                      required
                    />
                  </RB.Col>
                  <RB.Col md={3} className="mb-2">
                    <Select
                      options={department}
                      value={departmentFilter}
                      onChange={(selectedOption) =>
                        setDepartmentFilter(selectedOption)
                      }
                      placeholder="Select Department"
                      isClearable
                    />
                  </RB.Col>
                  <RB.Col md={3} className="mb-2 d-flex gap-2">
                    <RB.Button variant="primary" onClick={handleSearch}>
                      Search
                    </RB.Button>
                    <RB.Button variant="secondary" onClick={handleReset}>
                      Reset
                    </RB.Button>
                  </RB.Col>
                </RB.Row>
                <table
                  className="table text-center compact-table"
                  id="attendance-table"
                  border={1}
                >
                  <thead>
                    <tr>
                      {attendance?.headers?.map((header, i) => {
                        const totalIndex = attendance.headers.indexOf("Total");
                        const totalColSpan =
                          attendance.day_names.length - totalIndex + 1;
                        if (header === "Total") {
                          return (
                            <th
                              key={i}
                              colSpan={totalColSpan}
                              className="first-header"
                            >
                              {header}
                            </th>
                          );
                        }
                        if (i < totalIndex) {
                          return (
                            <th key={i} className="first-header">
                              {header}
                            </th>
                          );
                        }
                        return null;
                      })}
                    </tr>
                    <tr>
                      {attendance?.day_names?.map((day, i) => (
                        <th key={i} className="second-header">
                          {day}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredRows?.map((emp, idx) => (
                      <tr key={idx}>
                        <td>{emp?.sr_no}</td>
                        <td className="text-start">{emp?.employee_name}</td>
                        <td className="text-start">{emp?.employee_code}</td>
                        <td className="text-start">{emp?.department}</td>
                        {[...Array(31)].map((_, dayIdx) => {
                          const day = `${dayIdx + 1}`;
                          const dayName = attendance?.day_names?.[dayIdx + 4];
                          const value = emp?.attendance[day] || "";

                          let cellClass = "";

                          if (value === "P") {
                            cellClass = "bg-success text-white";
                          } else if (value !== "A") {
                            cellClass = "bg-warning text-dark";
                          }

                          return (
                            <td
                              key={dayIdx}
                              className={`${
                                dayName === "Sun" ? "sunday" : ""
                              } ${cellClass}`}
                            >
                              {value}
                            </td>
                          );
                        })}

                        {Object.keys(emp?.leave_counts).map((type) => (
                          <td key={type}>{emp?.leave_counts?.[type] || 0}</td>
                        ))}
                        <td>{emp?.holiday}</td>
                        <td>{emp?.travelCount}</td>
                        <td>{emp?.wfhCount}</td>
                        <td>{emp?.present}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )
          )}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Report;
